const REGISTRATION_WINDOW_MS = 60 * 60 * 1000;

function isWithinWindow(iso: string | undefined): boolean {
  if (!iso) {
    return false;
  }
  const created = Date.parse(iso);
  return (
    !Number.isNaN(created) && Date.now() - created < REGISTRATION_WINDOW_MS
  );
}

export function isRecentUserRegistration(user: {
  is_anonymous?: boolean;
  created_at?: string;
  identities?: Array<{ provider?: string; created_at?: string }> | null;
}): boolean {
  if (user.is_anonymous) {
    return false;
  }
  if (isWithinWindow(user.created_at)) {
    return true;
  }
  return (
    user.identities?.some(
      (identity) =>
        identity.provider !== "anonymous" &&
        isWithinWindow(identity.created_at),
    ) ?? false
  );
}
